import React from "react";
import { Box, Typography, LinearProgress, Chip } from "@material-ui/core";
import CalendarIcon from "@material-ui/icons/CalendarToday";
import { useTranslation } from "react-i18next";

const moment = require("moment");

const LimitProgressIndicator = (props) => {
  const { t } = useTranslation();

  let { value, freeSessionsLimit, maxSessionsLimit, reinitializeDate } = props;

  let freeSessionWidth = (freeSessionsLimit / maxSessionsLimit) * 100; // Proportion pour les free sessions (50% de l'espace total)
  let paidSessionWidth =
    ((maxSessionsLimit - freeSessionsLimit) / maxSessionsLimit) * 100;

  if (freeSessionWidth < 0 || paidSessionWidth < 0) {
    freeSessionWidth = 50;
    paidSessionWidth = 50;
  }

  // if (!reinitializeDate) {
  //   reinitializeDate = moment()
  //     .startOf("month")
  //     .add(1, "month")
  //     .format("DD/MM/YYYY");
  // }

  return (
    // <Box display="flex" flexDirection="row" alignItems="center">
    <Box style={{ width: "100%" }}>
      <Box
        display={"flex"}
        width="100%"
        justifyContent="space-between"
        alignItems="center"
        mb={2}
      >
        <Typography
          variant="h6"
          style={{
            fontSize: "16px",
            fontWeight: 600,
            color: "#374151",
          }}
        >
          {t("progress_indicator.sessions_this_month")}
        </Typography>

        {reinitializeDate && (
          <Chip
            icon={<CalendarIcon style={{ fontSize: "16px" }} />}
            label={`${t("progress_indicator.reset_on")} ${reinitializeDate}`}
            style={{
              backgroundColor: "rgba(59, 130, 246, 0.1)",
              color: "#3B82F6",
              fontWeight: 500,
              fontSize: "12px",
              height: "28px",
              borderRadius: "14px",
            }}
          />
        )}
      </Box>

      {/* Légende de la barre. Les deux libellés ne suivent volontairement pas
          les proportions des segments : quand le quota gratuit est petit devant
          le maximum, le segment correspondant ne fait que quelques pourcents de
          largeur, et un libellé calé sur cette largeur débordait par-dessus le
          suivant. On les pousse donc aux deux extrémités. */}
      <Box
        display="flex"
        width="100%"
        justifyContent="space-between"
        flexWrap="wrap"
      >
        <Typography style={{ fontSize: "12px", marginRight: 12 }}>
          {Math.min(value, freeSessionsLimit)}/{freeSessionsLimit}{" "}
          {t("progress_indicator.free_sessions")}
        </Typography>
        <Typography style={{ fontSize: "12px", textAlign: "right" }}>
          {value - freeSessionsLimit > 0 ? value - freeSessionsLimit : 0}/
          {maxSessionsLimit - freeSessionsLimit}{" "}
          {t("progress_indicator.paid_sessions")}
        </Typography>
      </Box>

      <Box
        width="100%"
        position="relative"
        display="flex"
        flexDirection="row"
        //   gap={2}
        alignItems="center"
      >
        {/* Barre bleue pour la partie avant maxSessionsLimit */}
        <LinearProgress
          variant="determinate"
          value={(Math.min(value, freeSessionsLimit) / freeSessionsLimit) * 100}
          style={{
            height: 10,
            backgroundColor: "#add8e6", // Bleu clair pour l'arrière-plan
            width: `${freeSessionWidth}%`,
          }}
          sx={{
            "& .MuiLinearProgress-bar": {
              backgroundColor: "#3f51b5", // Bleu pour la partie remplie
            },
          }}
        />
        <Box
          sx={{
            height: "20px", // Hauteur du trait
            width: "2px", // Largeur du trait (épaisseur)
            backgroundColor: "grey", // Couleur du trait
            margin: "0 0", // Marges autour du trait
          }}
        />
        {/* Barre rouge pour la partie après maxSessionsLimit */}
        <LinearProgress
          variant="determinate"
          value={
            (Math.min(
              value - freeSessionsLimit,
              maxSessionsLimit - freeSessionsLimit
            ) /
              (maxSessionsLimit - freeSessionsLimit)) *
            100
          }
          style={{
            //   position: "absolute",
            //   left: `${(maxSessionsLimit / 100) * 100}%`, // Commence à maxSessionsLimit
            width: `${paidSessionWidth}%`,
            // width: `${100 - maxSessionsLimit}%`,
            backgroundColor: "#add8e6", // Bleu clair pour l'arrière-plan
            height: 10,
          }}
          sx={{
            "& .MuiLinearProgress-bar": {
              backgroundColor: "#3f51b5", // Rouge pour la partie remplie après maxSessionsLimit
            },
          }}
        />
        {/* </Box> */}
        {/* <Box minWidth={35}>
        <Typography variant="body2" color="textSecondary">
          {`${value} / ${maxSessionsLimit}`}
        </Typography>
      </Box> */}
      </Box>
    </Box>
  );
};

export default LimitProgressIndicator;
